import { OnDataOptions, gql, useSubscription } from "@apollo/client";

const signInStart = gql`
subscription {
    signInStart(input: {provider: "google", jwtDuration: 2629800}) { # 2629800 = one month in seconds
        authLink,
        resultJWT
    }
}
`;

export default function Login({ client, setJwt }: {
    client: any,
    setJwt: React.Dispatch<React.SetStateAction<string | null>>
}) {

    const { data } = useSubscription(
        signInStart, {
        client: client, onData: (options: OnDataOptions<any>) => {
            if (options?.data?.data?.signInStart?.resultJWT) {
                setJwt(options?.data?.data?.signInStart?.resultJWT);
                localStorage.setItem("jwt", options?.data?.data?.signInStart?.resultJWT);
            } else {
                window.open(data?.signInStart?.authLink, "Google Login");
            }
        }
    });

    return <>
        <a className="btn btn-primary" href={data?.signInStart?.authLink} target="Google Login">Log In</a>
    </>
}